import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http'
import { Constant } from '../../environments/constants';
import { Utils } from '../../utils/utils';
import { DataService } from './context/data.service';
import { AppMonitoringService } from '../services/util/app-monitoring.service';
import * as fromModel from '../services/models/';
import { UserService } from './context/user.service';
import { ContextService } from './context/context.service';
import { AccountsService } from './accounts.service';
import { ClientsService } from './clients.service';
import { SAVINGSTYPE } from '../services/models/';

@Injectable({
  providedIn: 'root'
})
export class PlanService {

  

  constructor(private http: HttpClient, 
              private contextService: ContextService,
              private clientsService: ClientsService,
              private accountsService: AccountsService,
              private appMonitoringService: AppMonitoringService,
              private userService: UserService) { }

  savePlanAPI(plan) {
    return this.http.post<any>(Constant.uri.planSave, plan, Utils.getHttpOptions());
  } 

  savePlan(plan: fromModel.Plan, dataService: DataService) {
    //plan.savings = this.prepareSavings();
    //plan = null;
    this.savePlanAPI(plan).subscribe(result=>{
      this.contextService.dispatchAction(fromModel.APP_ACTION.PLAN,"PlanService-savePlan", result['plan']);
      dataService.dispatchAction(fromModel.DATA_ACTION.PLANIDNAME,"PlanService-savePlan", result['plan']);        
    }, err=>{
      dataService.dispatchAction(fromModel.DATA_ACTION.PLANIDNAME,"PlanService-savePlan", {Error: fromModel.ERRORCODE.APIERROR, ErrorDetails: JSON.stringify(err)});   
      console.log("Error creaing or saving Plan (PlanService-savePlan) - " + JSON.stringify(err));      
      this.appMonitoringService.traceMsg("Error creaing or saving Plan (PlanService-savePlan) - ", JSON.stringify(err) , 'Error');
    });
  }


  getPlanList(){
    console.log("Enter: PlanService getPlanList - Get Plan List Service");
    let user: fromModel.User = this.userService.getUser();

    let planListInput = { "issuperuser": user.isSuperUser,
                          "isfacetable": true,
                          "lstrepid": user.repIds                          
    };    
    console.log("Enter: PlanService getPlanList - Get Plan List Service");    
    return this.http.post<any>(Constant.uri.planList, planListInput, Utils.getHttpOptions());      
  }

  getPlanDetailsAPI(planId){
    return this.http.get<any>(Constant.uri.planDetails + planId, Utils.getHttpOptions());  
  }

  getPlanDetails(planId, dataService: DataService) {
    console.log("Enter: PlanService-getPlanDetails - Get Plan Details for Plan Id" + planId + " Service");
    console.log("Exit: PlanService-getPlanDetails - Get Plan Details for Plan Id" + planId + " Service");    

    this.getPlanDetailsAPI(planId).subscribe(pList => {
      if(pList && pList['plans'] && pList['plans'].length>0){
        let _plan = pList['plans'][0];
        if(_plan){
          this.contextService.dispatchAction(fromModel.APP_ACTION.PLAN, "PlanService-loadPlan",_plan);          
          dataService.dispatchAction(fromModel.DATA_ACTION.PLAN, "PlanService-loadPlan", _plan);   
          let planClientIds = [];
          let allAccountIds = [];
          _plan['planClients'].forEach(pCl => {
            planClientIds.push(pCl.clientid);
          });
          this.clientsService.getClientDetails(_plan['planClients'], dataService);
          // this.clientsService.getClientAPI(planClientIds).subscribe(clients=>{
          //   clients['value'].forEach(cl => {
          //     cl.Account.forEach(acc => {
          //       allAccountIds.push(acc);  
          //     });              
          //     cl.externalAccounts.forEach(extAcc => {
          //       allAccountIds.push(extAcc);  
          //     });
          //   });
          //   this.contextService.dispatchAction(fromModel.APP_ACTION.ACCOUNT, "PlanService-getPlanDetails",allAccountIds);                   
          //   dataService.dispatchAction(fromModel.DATA_ACTION.CLIENTS,"PlanService-getPlanDetails", clients);
          //   this.accountsService.getAccounts(allAccountIds, dataService);
          // }, err=>{  
          //   dataService.dispatchAction(fromModel.DATA_ACTION.CLIENTS,"PlanService-getPlanDetails-ClientDetails", {Error: fromModel.ERRORCODE.APIERROR, ErrorDetails: JSON.stringify(err)});
          //   console.log("Error getting Client Details: " + JSON.stringify(err));      
          //   this.appMonitoringService.traceMsg("Error getting Client Details: ", JSON.stringify(err) , 'Error');            
          // });
        }
      }
    }, err=>{   
      dataService.dispatchAction(fromModel.DATA_ACTION.PLAN,"PlanService-getPlanDetails", {Error: fromModel.ERRORCODE.APIERROR, ErrorDetails: JSON.stringify(err)});   
      console.log("Error getting Plan List - PlanService-getPlanDetails");      
      this.appMonitoringService.traceMsg("Error: Error getting Plan List - PlanService-getPlanDetails", JSON.stringify(err), 'Error');
    });
      
  }

  deletePlan(planId) {
    console.log("Enter: PlanService - Delete Plan for Plan Id" + planId + " Service");
    
    console.log("Exit: PlanService - Delete Plan for Plan Id" + planId + " Service");
    return this.http.post<any>(Constant.uri.planDelete + planId, Utils.getHttpOptions());  

    

  }

  prepareSavings(){
    let savings: fromModel.Saving[] = [{
      actId: "RJM005352",
      savId: "1",
      savDesc: "First Saving",
      savType: fromModel.SAVINGSTYPE.SC,
      growthRate: 2,
      growthType: fromModel.GROWTHTYPE.MNF,
      isIncluded: true,
      isMonthly: false,
      owner: '449b5f0926336fa7546fa00129ff739f2e8f126111b46e42ddb9a59bf28ff463',
      amtPeriod: [{startType: fromModel.AMOUNTPERIODTYPE.Year, 
        startYr: 2021, 
        endType: fromModel.AMOUNTPERIODTYPE.AtRet,
      amount: 24000}]
    }];
    return savings;
  }

  

}
